(() => {
  function init(root = document) {
    const header = root.querySelector('.alpha-additive-header');
    if (!header || header.dataset.alphaInitialized) return;
    header.dataset.alphaInitialized = 'true';
    const sync = () => {
      const wrap = header.closest('#StickyHeaderWrap');
      if (wrap) wrap.style.height = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };
    const observer = new ResizeObserver(sync);
    observer.observe(header);
    header.addEventListener('alpha:unload', () => observer.disconnect(), {once:true});
    // Keep the native search component and its server-rendered results. Only
    // close its existing result surface when this always-visible field is left.
    const search = header.querySelector('predictive-search');
    if (search) {
      const closeOutside = event => {
        if (search.classList.contains('is-active') && !search.contains(event.target)) search.close?.();
      };
      document.addEventListener('pointerdown', closeOutside);
      header.addEventListener('alpha:unload', () => document.removeEventListener('pointerdown',closeOutside), {once:true});
      search.addEventListener('focusout', event => {
        if (event.relatedTarget && !search.contains(event.relatedTarget)) search.close?.();
      });
    }
    requestAnimationFrame(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('.alpha-additive-header')?.dispatchEvent(new Event('alpha:unload')));
})();
